__turbopack_context__.v({
  "absoluteActions": "IdentityHeader-module__hVzuGW__absoluteActions",
  "actionsRow": "IdentityHeader-module__hVzuGW__actionsRow",
  "avatar": "IdentityHeader-module__hVzuGW__avatar",
  "avatarImage": "IdentityHeader-module__hVzuGW__avatarImage",
  "fullName": "IdentityHeader-module__hVzuGW__fullName",
  "fullNameBox": "IdentityHeader-module__hVzuGW__fullNameBox",
  "identityCard": "IdentityHeader-module__hVzuGW__identityCard",
  "mainRole": "IdentityHeader-module__hVzuGW__mainRole",
  "roleTip": "IdentityHeader-module__hVzuGW__roleTip",
  "roleTipIn": "IdentityHeader-module__hVzuGW__roleTipIn",
});
